module.exports = __webpack_public_path__ + "img/image-up.973e92a9.svg";